export default __webpack_public_path__ + "static/media/rcm-logo-white.54f4e7ff.svg";